export const ROLES_ABSOLUTE_ROUTE_PREFIX = '/navix-admin/role/s' as const
export const DELETE_ROLE_DIALOG_ID = 'DELETE_ROLE_DIALOG_ID' as const
